import { FUND_TYPES } from '../../constants/constants';
import ModifyCaresBenefit from './fundtypes/cares/ModifyCaresBenefit';
import ReadOnlyLiheapBenefit from './fundtypes/liheap/ReadOnlyLiheapBenefit';
import EditableWinterHelpBenefit from './fundtypes/winterhelp/EditableWinterHelpBenefit';
import EditableOtherFundBenefit from './fundtypes/other/EditableOtherFundBenefit';
import EditablePpcBenefit from './fundtypes/ppc/EditablePpcBenefit';

const ModifyBenefitFundTypeRenderer = ({
  benefit,
  pledgeAmount,
  incomeMeasurementType,
  incomeMeasurementPercentage,
  arrearsLiabilityAmount,
  setFormField,
  isSubmitting,
}) => {

  switch (benefit.fundType) {
    case FUND_TYPES.CARES:
      return <ModifyCaresBenefit
        benefit={benefit}
        incomeMeasurementType={incomeMeasurementType}
        incomeMeasurementPercentage={incomeMeasurementPercentage}
        arrearsLiabilityAmount={arrearsLiabilityAmount}
        onArrearsLiabilityAmountChange={value => setFormField('arrearsLiabilityAmount', value)}
        pledgeAmount={pledgeAmount}
        onPledgeAmountChange={value => setFormField('pledgeAmount', value)}
        isSubmitting={isSubmitting}
      />;
    case FUND_TYPES.LIHEAP:
      return <ReadOnlyLiheapBenefit
        pledgeAmount={pledgeAmount}
        additionalInformation={benefit.additionalInformation}
      />;
    case FUND_TYPES.PPC:
      return <EditablePpcBenefit
        incomeMeasurementType={incomeMeasurementType}
        incomeMeasurementPercentage={incomeMeasurementPercentage}
        arrearage={benefit.arrearage}
        energyDiscount={benefit.energyDiscount}
        pledgeAmount={pledgeAmount}
        onPledgeAmountChange={value => setFormField('pledgeAmount', value)}
        isSubmitting={isSubmitting}
      />;
    case FUND_TYPES.WINTERHELP:
      return <EditableWinterHelpBenefit
        pledgeAmount={pledgeAmount}
        onPledgeAmountChange={value => setFormField('pledgeAmount', value)}
        isSubmitting={isSubmitting}
      />;
    case FUND_TYPES.OTHER:
    default:
      return <EditableOtherFundBenefit
        state={benefit.state}
        pledgeAmount={pledgeAmount}
        onPledgeAmountChange={value => setFormField('pledgeAmount', value)}
        incomeMeasurementType={incomeMeasurementType}
        onIncomeMeasurementTypeChange={value => setFormField('incomeMeasurementType', value)}
        incomeMeasurementPercentage={incomeMeasurementPercentage}
        onIncomeMeasurementPercentageChange={value => setFormField('incomeMeasurementPercentage', value)}
        isSubmitting={isSubmitting}
      />;
  }
};

export default ModifyBenefitFundTypeRenderer;